import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/website/assets/img/business/rate-1.png")